import jwtDecode from "jwt-decode";
import {ADMIN, STUDENT, TEACHER} from "../utils";

export const getToken = () => {
    return localStorage.getItem('token');
}

export const getRole = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
        return jwtDecode(token).role;
    } catch (e) {
        return null;
    }
};

export const isTeacher = () => {
    return getRole() === TEACHER;
}

export const isStudent = () => {
    return getRole() === STUDENT;
}

export const isAdmin = () => {
    return getRole() === ADMIN;
}